import React from "react"
import RichTextEditor from "../RichTextEditor/RichTextEditor"
import ModalButtons from "../ModalButtons/ModalButtons"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"

export default class SendEmail extends React.Component{

  constructor(props) {
    super(props);

    this.state = {
      error: null,
      success: null,
      loading: false,
      from_address: this.props.email && this.props.email.from_address ? this.props.email.from_address : '',
      to_addresses: this.props.email && this.props.email.to_addresses ? this.props.email.to_addresses : '',
      cc_addresses: this.props.email && this.props.email.cc_addresses ? this.props.email.cc_addresses : '',
      bcc_addresses: this.props.email && this.props.email.bcc_addresses ? this.props.email.bcc_addresses : '',
      subject: this.props.email && this.props.email.subject ? this.props.email.subject : '',
      html_body: this.props.email && this.props.email.html_body ? this.props.email.html_body : '',
    };

    this.onChange = this.onChange.bind(this)
    this.onChangeBody = this.onChangeBody.bind(this)
    this.onChangeEditor = this.onChangeEditor.bind(this)
    this.sendEmail = this.sendEmail.bind(this)
  }

  componentDidMount() {
    // this.setupNavigation();
    // this.setupEditor();
  }

  // setupNavigation() {
  //   var self = this;
  //   var $sendEmail = $('.modal-footer .btn');
  //   var $cancel = $sendEmail.clone().text(I18n.t('cancel'));

  //   $sendEmail.text(I18n.t('send_now')).removeClass('btn-dark').attr('data-style', 'zoom-in').addClass('btn-primary').addClass('ladda-button').wrapInner('<span class="ladda-label"></span>').on('click', () => {
  //     self.sendEmail();
  //     return false;
  //   });

  //   setTimeout(function () {
  //     self.laddaSendButton = Ladda.create($sendEmail[0]);
  //   }, 1000);

  //   $sendEmail.before($cancel);
  // }

  // getRedactor() {
  //   return $(this.refs.editor).redactor('core.object');
  // }

  // getEditor() {
  //   return $(this.refs.editor).redactor('core.editor');
  // }

  // getEditorHTML() {
  //   return $(this.refs.editor).redactor('code.get');
  // }

  render() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('send_now'),
        button_classes: ['primary'],
        onClick: this.sendEmail,
      },
    ]

    return (
      <div className="resend-email">
        <LoadingSpinner show={this.state.loading} />
        <ModalButtons loading={this.state.loading} buttons={buttons} />
        {this.state.error ? <div className="alert alert-danger">{this.state.error}</div> : null}
        {this.state.success ? <div className="alert-success">{this.state.success}</div> : null}

        <div className="to-cc-bcc-subject">
          <div className="row">
            <div className="col-sm-12">
              <div className="input-group">
                <div className="input-group-addon">{I18n.t('from')}</div>
                <input type="text" name="email[from_address]" ref="from_address" data-name="from_address" className='form-control' defaultValue={this.state.from_address} onChange={this.onChange.bind(null, 'from_address')} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="input-group">
                <div className="input-group-addon">{I18n.t('to')}</div>
                <input type="text" name="email[to_addresses]" ref="to_addresses" data-name="to_addresses" className='form-control' defaultValue={this.state.to_addresses} onChange={this.onChange.bind(null, 'to_addresses')} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <div className="input-group">
                <div className="input-group-addon">{I18n.t('cc')}</div>
                <input type="text" name="email[cc_addresses]" ref="cc_addresses" data-name="cc_addresses" className='form-control' defaultValue={this.state.cc_addresses} onChange={this.onChange.bind(null, 'cc_addresses')} />
              </div>
            </div>

            <div className="col-sm-6">
              <div className="input-group">
                <div className="input-group-addon">{I18n.t('bcc')}</div>
                <input type="text" name="email[bcc_addresses]" ref="bcc_addresses" data-name="bcc_addresses" className='form-control' defaultValue={this.state.bcc_addresses} onChange={this.onChange.bind(null, 'bcc_addresses')} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="input-group">
                <div className="input-group-addon">{I18n.t('subject')}</div>
                <input type="text" name="email[subject]" ref="subject" data-name="subject" className='form-control' defaultValue={this.state.subject} onChange={this.onChange.bind(null, 'subject')} />
              </div>
            </div>
          </div>
        </div>
        <div className="editor" ref="inner">
          <RichTextEditor body={this.state.html_body} onChange={this.onChangeBody} auto_resize={true}/>
        </div>
      </div>
    );
  }

  onChange(name, event) {
    var state = this.state;
    state[name] = event.target.value;
    this.setState(state);
  }

  onChangeBody(body) {
    this.setState({html_body: body});
  }

  onChangeEditor() {
    this.setState({html_body: this.getEditorHTML()});
  }

  sendEmail() {
    var self = this;
    this.setState({loading: true})
    $.ajax({
      type: 'POST',
      url: this.props.path,
      data: {
        from_address: this.state.from_address,
        to_addresses: this.state.to_addresses,
        cc_addresses: this.state.cc_addresses,
        bcc_addresses: this.state.bcc_addresses,
        subject: this.state.subject,
        html_body: this.state.html_body,
        reservation_id: this.props.reservation_id,
        reservation_segment_id: this.props.reservation_segment_id,
        folio_id: this.props.folio_id,
        order_id: this.props.order_id,
        id: this.props.email_id
      },
    }).done((data) => {
      // if (self.laddaSendButton) {
      //   self.laddaSendButton.stop();
      // }

      if (data.error) {
        self.setState({loading: false, error: data.error});
      } else if (data.success) {
        self.setState({success: data.success, loading: false}, () => {
          if (parent && parent.refresh_data) {
            parent.refresh_data(I18n.t('email_sent_successfully'));
          }
          window.handleAlertSuccess();
          if (parent && parent.hide_modal) {
            parent.hide_modal();
          }
        });
      }
    });
  }

};
